import React from "react";
import liveSessionCup from "../../../../../../assets/images/LearningSession/LiveSession.png";
import liveSessionBanner from "../../../../../../assets/images/LearningSession/liveSessionBanner.png";
import TableSearchPagination from "../TableSearchPagination/TableSearchPagination";
import "./LiveSessionResult.css";

const LiveSessionResult = () => {
  return (
    <div className="m-2 border border-warning rounded-3">
      <div className=" p-3">
        <div className="d-flex my-2">
          <img src={liveSessionCup} alt="" />
          <h3 className="text-light mx-2">Live Session Result</h3>
        </div>

        <div className="my-3">
          <img
            src={liveSessionBanner}
            alt=""
            className="rounded img-fluid w-100 mobileNx"
          />
        </div>

        <div>
          <h5 className="my-3 text-light">Upload Video Instruction</h5>

          <div className="bg-dark py-3">
            <p className="text-light px-3">
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Doloremque cum omnis, totam sit nostrum impedit, nemo consequuntur
              tempore veritatis ipsam consequatur? Adipisci mollitia corporis
              nobis, in placeat omnis impedit! Adipisci!
            </p>
          </div>

          <div className="my-3 py-3 bg-dark px-3 my-2">
            <h4 className="text-light">Learning Session Result</h4>
          </div>

          <div>
            <TableSearchPagination />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveSessionResult;
